import m from 'mithril'
import classNames from 'classnames'
import {
    Guide
} from "app/models"
import stream from 'mithril/stream'
import {
    Dialog
} from 'components'
import moment from 'moment'
import {
    GuidesPhotosUploader,
} from 'components/uploader'

class GuidePage {
    constructor() {
        this.guides = stream([])

        this.types = [
            { id: 'first_login_tw', name: '第一次使用_TW' },
            { id: 'first_login_en', name: '第一次使用_EN' },
        ]

        this.select_type = null
        this.changeType = false

    }
    view() {
        return [
            m(".row",
                m(".col-xl-12",
                    m(".breadcrumb-holder", [
                        m("h3.main-title.float-left", "新手導覽"),
                        m("ol.breadcrumb.float-right",
                            [
                                m("li.breadcrumb-item.active", "新手導覽/首頁")
                            ]
                        ), m(".clearfix")
                    ])
                )
            ),
            m(".row.pb-3", [
                m(".col-12.d-flex.align-items-end.border-bottom.pb-3.justify-content-between", [
                    m("span.pl-3", {
                        style: {
                            fontSize: "1.2rem"
                        }
                    }
                        , "新手導覽列表"),

                ]),
            ]),

            m(".row.w-100", [
                m(".col-7.d-flex", [
                    this.types.map((_type) => {
                        return [
                            m("button.btn.btn-sm.btn-outline-primary.px-2", {
                                class: classNames({
                                    "active": this.select_type == _type.id
                                }),
                                onclick: (e) => {
                                    e.preventDefault()
                                    this.select_type = _type.id
                                    this.changeType = false
                                    Guide.fetch(this.select_type).then((_response) => {
                                        this.guides(_response)
                                        this.changeType = true
                                    })
                                }
                            }, [m("span", _type.name),]),
                            m(".px-1")
                        ]
                    })
                ]),
                m(".col-4.d-flex.py-2", [
                    m("button.btn.btn-sm[type='button'].px-2", {
                        style: {
                            background: "#e32d80"
                        },
                        onclick: (e) => {
                            e.preventDefault()
                        }
                    }, [m("span.text-light", "尺寸：870*1883")]),
                    m(".px-1"),
                    m("button.btn.btn-sm[type='button'].px-2", {
                        style: {
                            background: "#e32d80"
                        },
                        onclick: (e) => {
                            e.preventDefault()
                        }
                    }, [m("span.text-light", "拖拉縮圖以調整順序")]),
                ]),
            ]),
            m(".row.w-100.pl-2", [
                (this.select_type != null && this.changeType == true) ?
                    [
                        m("button.btn.btn-primary.btn-sm[type='button']", {
                            onclick: (e) => {
                                e.preventDefault()
                                Guide.save(this.guides()).then((response) => {
                                    swal.fire({
                                        title: "儲存完畢!",
                                        text: "已成功編輯資訊，請至列表查看!!",
                                        icon: "success",
                                        buttons: false,
                                        timer: 1800,
                                    })
                                })
                            }
                        }, [m("i.fa.fa-plus-circle.mr-1"), "儲存首頁視覺圖"]),
                        m(GuidesPhotosUploader, {
                            items: this.guides,
                            type: this.select_type,
                            temppath: `${window.BASE_URL}/temp/`,
                            storepath: `${window.BASE_URL}/images/guides/`,
                            url: `${window.BASE_URL}/api/upload/guide`,
                            width: 870,
                            height: 1883,
                            folder: "guides"
                        })
                    ] : "",

            ]),
        ]
    }
}

export default GuidePage